import {Pipe, PipeTransform} from '@angular/core';

@Pipe({
  name: 'numberfr'
})
export class FrenchDecimalPipe implements PipeTransform {

  transform(val: number): string {
    if (val !== undefined && val !== null) {
      return val.toString().replace(/,/g, " ");
    } else {
      return "";
    }
  }
}



// WEBPACK FOOTER //
// ./src/shared/pipes/french-decimal/french-decimal.ts